import React, { useEffect, useState, useContext } from "react";
import Footer10 from "../shared/Footer10";
import Navbar10 from "../shared/Navbar10";
import Sidebar10 from "../shared/Sidebar10";
import { useNavigate, useLocation } from "react-router-dom";
import { setSessionData, getSessionData } from "../../cache";
import Swal from "sweetalert2";
import { ContextBoard } from "../../context/ContextBoard";
import config from "../../config";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

function Exregularsecond10() {
  const {
    setCandidateid10,
    setCastecode10,
    setDivyangcode10,
    candidateid10,
    mode10,
    setMode10,
    setDocverify,
    class10regulardata,
  } = useContext(ContextBoard);
  const Navigate = useNavigate();
  const location = useLocation();
  const { studentData } = location.state || {};
  console.log("studentData:", studentData.candidatE_ID);

  const [loading, setLoading] = useState(true);

  const [casteList, setCasteList] = useState([]);
  const [divyangList, setDivyangList] = useState([]);
  const [mediumList, setMediumList] = useState([]);
  const [language1_2new, setLanguage1_2new] = useState([]);
  const [additional, setAdditional] = useState([]);
  const [compulsary, setCompulsary] = useState([]);
  const [compulsory_one, setCompulsoryOne] = useState("");
  const [compulsory_two, setCompulsoryTwo] = useState("");
  const [compulsory_three, setCompulsoryThree] = useState("");

  const [errors, setErrors] = useState({});
  const [isPreviewed, setIsPreviewed] = useState(false);
  const [isAgreed, setIsAgreed] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);

  const [finaledit, setFinaledit] = useState(false);

  const [formData, setFormData] = useState({
    examyear: "",
    attempt: "",
    class_roll_no: "",
    section_val: "",
    registration_no: "",
    registration_session: "",
    reg_session_name: "",
    registration_number: "",
    candidate_name: "",
    gender: "",
    date_of_birth: "",
    fathers_name: "",
    mothers_name: "",
    religion: "",
    nationality: "Indian",
    aadhaar_no: "",
    divyang_val: "",
    caste_val: "",
    area: "",
    state_val: "",
    district_val: "",
    block_val: "",
    address_val: "",
    pin_no: "",
    contact_no: "",
    email_id: "",
    category_choice: "",
    board_name: "",
    examination_medium: "",
    language_one: "",
    language_two: "",
    compulsory_one: "",
    compulsory_two: "",
    compulsory_three: "",
    additional_subject: "",
    language_one_code: "",
    language_two_code: "",
    compulsory_one_code: "",
    compulsory_two_code: "",
    compulsory_three_code: "",
    additional_subject_code: "",
    apaar_id: "",
  });

  useEffect(() => {
    if (studentData === null || studentData === undefined) {
      Navigate("/class-x-dashboard");
      return;
    }
    if (mode10 === "edit") {
      setFinaledit(true);
      setIsEditMode(true);
      setIsPreviewed(true);
    }
    const casteList = getSessionData("casteList") || [];
    const divyangList = getSessionData("divyangList") || [];
    const mediumList = getSessionData("mediumList") || [];

    const language1_2 = getSessionData("language1_2") || [];
    const additional = getSessionData("additional") || [];
    const compulsary = getSessionData("compulsary") || [];
    const compulsory_one = getSessionData("compulsory_one") || [];
    const compulsory_two = getSessionData("compulsory_two") || [];
    const compulsory_three = getSessionData("compulsory_three") || [];
    // 🔹 Set lists into state

    setCasteList(Array.isArray(casteList) ? casteList : []);

    setDivyangList(Array.isArray(divyangList) ? divyangList : []);
    setMediumList(Array.isArray(mediumList) ? mediumList : []);

    setLanguage1_2new(Array.isArray(language1_2) ? language1_2 : []);
    setAdditional(Array.isArray(additional) ? additional : []);
    setCompulsary(Array.isArray(compulsary) ? compulsary : []);
    setCompulsoryOne(compulsory_one ? compulsory_one : []);
    setCompulsoryTwo(compulsory_two ? compulsory_two : []);
    setCompulsoryThree(compulsory_three ? compulsory_three : []);

    // 🔹 Set common student details
    setFormData((prev) => ({
      ...prev,
      registration_no: studentData?.data?.exRegularStudentCL10_data
        ?.registratioN_ID_CL_9
        ? studentData?.data?.exRegularStudentCL10_data?.registratioN_ID_CL_9
        : studentData.registratioN_NO
        ? studentData.registratioN_NO
        : "",
      gender: studentData?.data?.exRegularStudentCL10_data?.gender
        ? studentData?.data?.exRegularStudentCL10_data?.gender?.toUpperCase()
        : studentData.gender
        ? studentData.gender?.toUpperCase()
        : "",
      candidate_name: studentData?.data?.exRegularStudentCL10_data
        ?.candidatE_NAME
        ? studentData?.data?.exRegularStudentCL10_data?.candidatE_NAME
        : studentData.candidatE_NAME
        ? studentData.candidatE_NAME
        : "",
      date_of_birth: studentData?.data?.exRegularStudentCL10_data?.dob
        ? studentData?.data?.exRegularStudentCL10_data?.dob
        : studentData.dob
        ? studentData.dob
        : "",
      fathers_name: studentData?.data?.exRegularStudentCL10_data?.fatheR_NAME
        ? studentData?.data?.exRegularStudentCL10_data?.fatheR_NAME
        : studentData.fatheR_NAME
        ? studentData.fatheR_NAME
        : "",
      mothers_name: studentData?.data?.exRegularStudentCL10_data?.motheR_NAME
        ? studentData?.data?.exRegularStudentCL10_data?.motheR_NAME
        : studentData.motheR_NAME
        ? studentData.motheR_NAME
        : "",
      religion: studentData?.data?.exRegularStudentCL10_data?.religion
        ? studentData?.data?.exRegularStudentCL10_data?.religion
        : studentData.religion
        ? studentData.religion
        : "",
      nationality: studentData?.data?.exRegularStudentCL10_data?.nationality
        ? studentData?.data?.exRegularStudentCL10_data?.nationality
        : studentData.nationality
        ? studentData.nationality
        : "",
      aadhaar_no: studentData?.data?.exRegularStudentCL10_data?.aadhaR_CARD
        ? studentData?.data?.exRegularStudentCL10_data?.aadhaR_CARD
        : studentData.aadhaR_CARD
        ? studentData.aadhaR_CARD
        : "",
      apaar_id: studentData?.data?.exRegularStudentCL10_data?.apaaR_ID
        ? studentData?.data?.exRegularStudentCL10_data?.apaaR_ID
        : studentData.apaaR_ID
        ? studentData.apaaR_ID
        : "",
      divyang_val: studentData?.data?.exRegularStudentCL10_data?.divyang
        ? studentData?.data?.exRegularStudentCL10_data?.divyang
        : studentData.divyang
        ? studentData.divyang
        : "",
      caste_val: studentData?.data?.exRegularStudentCL10_data?.caste
        ? studentData?.data?.exRegularStudentCL10_data?.caste
        : studentData.caste
        ? studentData.caste
        : "",
      contact_no:
        studentData?.data?.exRegularStudentCL10_data?.contacT_NO || "",
      email_id: studentData?.data?.exRegularStudentCL10_data?.emaiL_ID || "",
      area: studentData?.data?.exRegularStudentCL10_data?.area || "",
      state_val: studentData?.data?.exRegularStudentCL10_data?.state || "",
      district_val:
        studentData?.data?.exRegularStudentCL10_data?.districT_ID || "",
      block_val: studentData?.data?.exRegularStudentCL10_data?.block || "",
      address_val: studentData?.data?.exRegularStudentCL10_data?.address || "",
      pin_no: studentData?.data?.exRegularStudentCL10_data?.pincode || "",
      class_roll_no:
        studentData?.data?.exRegularStudentCL10_data?.rolL_NO || "",
      examination_medium: studentData?.data?.exRegularStudentCL10_data
        ?.mediuM_OF_EXAM
        ? studentData?.data?.exRegularStudentCL10_data?.mediuM_OF_EXAM
        : studentData.mediuM_OF_EXAM
        ? studentData.mediuM_OF_EXAM
        : "",
      section_val: studentData?.data?.exRegularStudentCL10_data?.section || "",
      language_one: studentData?.data?.exRegularStudentCL10_data?.subjecT_NAME1
        ? studentData?.data?.exRegularStudentCL10_data?.subjecT_NAME1
        : studentData.subjecT_NAME1
        ? studentData.subjecT_NAME1
        : "",
      language_two: studentData?.data?.exRegularStudentCL10_data?.subjecT_NAME2
        ? studentData?.data?.exRegularStudentCL10_data?.subjecT_NAME2
        : studentData.subjecT_NAME2
        ? studentData.subjecT_NAME2
        : "",
      compulsory_one: studentData?.data?.exRegularStudentCL10_data
        ?.subjecT_NAME3
        ? studentData?.data?.exRegularStudentCL10_data?.subjecT_NAME3
        : studentData.subjecT_NAME3
        ? studentData.subjecT_NAME3
        : "",
      compulsory_two: studentData?.data?.exRegularStudentCL10_data
        ?.subjecT_NAME4
        ? studentData?.data?.exRegularStudentCL10_data?.subjecT_NAME4
        : studentData.subjecT_NAME4
        ? studentData.subjecT_NAME4
        : "",
      compulsory_three: studentData?.data?.exRegularStudentCL10_data
        ?.subjecT_NAME5
        ? studentData?.data?.exRegularStudentCL10_data?.subjecT_NAME5
        : studentData.subjecT_NAME5
        ? studentData.subjecT_NAME5
        : "",
      additional_subject: studentData?.data?.exRegularStudentCL10_data
        ?.subjecT_NAME6
        ? studentData?.data?.exRegularStudentCL10_data?.subjecT_NAME6
        : studentData.subjecT_NAME6
        ? studentData.subjecT_NAME6
        : "",
      language_one_code: studentData?.data?.exRegularStudentCL10_data?.subjecT_1
        ? studentData?.data?.exRegularStudentCL10_data?.subjecT_1
        : studentData.subjecT_1_CODE
        ? studentData.subjecT_1_CODE
        : "",
      language_two_code: studentData?.data?.exRegularStudentCL10_data?.subjecT_2
        ? studentData?.data?.exRegularStudentCL10_data?.subjecT_2
        : studentData.subjecT_2_CODE
        ? studentData.subjecT_2_CODE
        : "",
      compulsory_one_code: studentData?.data?.exRegularStudentCL10_data
        ?.subjecT_3
        ? studentData?.data?.exRegularStudentCL10_data?.subjecT_3
        : studentData.subjecT_3_CODE
        ? studentData.subjecT_3_CODE
        : "",
      compulsory_two_code: studentData?.data?.exRegularStudentCL10_data
        ?.subjecT_4
        ? studentData?.data?.exRegularStudentCL10_data?.subjecT_4
        : studentData.subjecT_4_CODE
        ? studentData.subjecT_4_CODE
        : "",
      compulsory_three_code: studentData?.data?.exRegularStudentCL10_data
        ?.subjecT_5
        ? studentData?.data?.exRegularStudentCL10_data?.subjecT_5
        : studentData.subjecT_5_CODE
        ? studentData.subjecT_5_CODE
        : "",
      additional_subject_code: studentData?.data?.exRegularStudentCL10_data
        ?.subjecT_6
        ? studentData?.data?.exRegularStudentCL10_data?.subjecT_6
        : studentData.subjecT_6_CODE
        ? studentData.subjecT_6_CODE
        : "",
      board_name: studentData?.data?.exRegularStudentCL10_data?.board
        ? studentData?.data?.exRegularStudentCL10_data?.board
        : studentData.boarD_NAME
        ? studentData.boarD_NAME
        : "",
      examyear:
        studentData?.data?.exRegularStudentCL10_data?.cL_10_EXAM_YEAR || "",
      registration_session:
        studentData?.data?.exRegularStudentCL10_data?.registratioN_SESSION ||
        "",
      reg_session_name: studentData?.data?.exRegularStudentCL10_data
        ?.sessioN_FULL_NAME
        ? studentData?.data?.exRegularStudentCL10_data?.sessioN_FULL_NAME
        : studentData.sessioN_FULL_NAME
        ? studentData.sessioN_FULL_NAME
        : "",
      category_choice: studentData?.data?.exRegularStudentCL10_data
        ?.studenT_EXAM_SUB_CATEGORY
        ? studentData?.data?.exRegularStudentCL10_data
            ?.studenT_EXAM_SUB_CATEGORY
        : studentData.studenT_EXAM_CATEGORY_DESCRIPTION
        ? studentData.studenT_EXAM_CATEGORY_DESCRIPTION
        : "",
      attempt: studentData?.data?.exRegularStudentCL10_data?.attempt || "",
    }));

    setLoading(false);
  }, []);

  const handleChange = (e) => {
    const { name, value = "" } = e.target;

    let formattedValue = value;

    // if (name === "religion") {
    //   formattedValue = value;
    // }

    setFormData((prev) => ({
      ...prev,
      [name]: formattedValue,
    }));

    if (errors[name]) {
      setErrors((prev) => ({ ...prev, [name]: "" }));
    }
  };

  const handlePreview = () => {
    setIsAgreed(false);
    setLoading(true);
    const trimmed = (val) => (val || "").trim();

    const newErrors = {};

    // if (!formData.divyang_val) {
    //   newErrors.divyang_val = "Divyang selection is required.";
    // }

    // if (!formData.caste_val) {
    //   newErrors.caste_val = "Caste is required.";
    // }

    setErrors(newErrors);
    const noErrors = Object.keys(newErrors).length === 0;

    if (!noErrors) {
      const firstErrorKey = Object.keys(newErrors)[0];
      const firstErrorElement = document.querySelector(
        `[name="${firstErrorKey}"]`
      );
      if (firstErrorElement) {
        firstErrorElement.focus();
      }
    } else {
      window.scrollTo({ top: 0, behavior: "smooth" });
      setIsPreviewed(true);
    }
    setLoading(false);
  };
  const handleEditClick = () => {
    Swal.fire({
      title: "Are you sure?",
      text: "Do you want to edit this profile?",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Yes, Edit",
      cancelButtonText: "Cancel",
    }).then((result) => {
      if (result.isConfirmed) {
        setIsEditMode(false);
        setIsPreviewed(false);
      }
    });
  };
  const handleContinueClick = async () => {
    if (!isAgreed) {
      await Swal.fire({
        icon: "warning",
        title: "Please Agree",
        text: "You must agree before submitting the form.",
      });
      return;
    }
    setCandidateid10(candidateid10 || "");
    setCastecode10(formData.caste_val || "");
    setDivyangcode10(formData.divyang_val || "");
    if (finaledit === false) {
      setDocverify(true);
      Navigate("/class-x-upload-document");
    } else {
      Navigate("/class-x-upload-document");
    }
  };
  const handleButtonClick = () => {
    const isEditMode = mode10;
    if (isEditMode === "edit") {
      handleEditSubmit();
    } else {
      handleSubmit();
    }
  };
  const handleSubmit = async () => {
    const token = sessionStorage.getItem("tokenclassx");

    // e.preventDefault();
    if (!isAgreed) {
      await Swal.fire({
        icon: "warning",
        title: "Please Agree",
        text: "You must agree before submitting the form.",
      });
      return;
    }

    const payload = {
      registratioN_NO: formData.registration_no || "",
      gender: formData.gender || "",
      candidatE_ID:
        studentData?.data?.exRegularStudentCL10_data?.candidatE_ID || "",
      candidatE_NAME: formData.candidate_name || "",
      dob: formData.date_of_birth || "",
      fatheR_NAME: formData.fathers_name || "",
      motheR_NAME: formData.mothers_name || "",
      religion: formData.religion || "",
      nationality: formData.nationality || "",
      aadhaR_CARD: formData.aadhaar_no || "",
      apaaR_ID: formData.apaar_id || "",
      divyang: formData.divyang_val || "",
      caste: formData.caste_val || "",
      contacT_NO: formData.contact_no || "",
      emaiL_ID: formData.email_id || "",
      area: formData.area || "",
      state: formData.state_val || "",
      districT_ID: formData.district_val || "",
      block: formData.block_val || "",
      address: formData.address_val || "",
      pincode: formData.pin_no || "",
      clasS_ROLL_NO: formData.class_roll_no || "",
      mediuM_OF_EXAM: formData.examination_medium || "",
      sectioN: formData.section_val || "",
      subjecT_1: formData.language_one_code || "",
      subjecT_2: formData.language_two_code || "",
      subjecT_3: formData.compulsory_one_code || "",
      subjecT_4: formData.compulsory_two_code || "",
      subjecT_5: formData.compulsory_three_code || "",
      subjecT_6: formData.additional_subject_code || "",
      boarD_NAME: formData.board_name || "",
      exaM_YEAR: formData.examyear || "",
      registratioN_SESSION: formData.registration_session || "",
      studenT_EXAM_SUB_CATEGORY: formData.category_choice || "",
      attempt: formData.attempt || "",
    };
    try {
      const response = await fetch(
        `${config.API_BASE_URL}/InsertExRegularStudentRegistration_CL10`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(payload),
        }
      );

      const data = await response.json();

      setCandidateid10(data.data.candidatE_CODE || "");
      setCastecode10(formData.caste_val || "");
      setDivyangcode10(formData.divyang_val || "");
      if (response.ok) {
        await Swal.fire({
          icon: "success",
          title: "Success",
          text: "Your data added successfully",
          confirmButtonText: "OK",
        });
        if (finaledit === false) {
          setDocverify(true);
          Navigate("/class-x-upload-document");
        } else {
          Navigate("/class-x-upload-document");
        }

        // window.location.reload();
      } else {
        await Swal.fire({
          icon: "error",
          title: "Submission Failed",
          text: data.message || "Something went wrong. Please try again.",
        });
      }
    } catch (error) {
      console.error("API Error:", error);
      await Swal.fire({
        icon: "error",
        title: "Network Error",
        text: "Please check your internet connection and try again.",
      });
    }
  };
  const handleEditSubmit = async () => {
    const token = sessionStorage.getItem("tokenclassx");

    if (!isAgreed) {
      await Swal.fire({
        icon: "warning",
        title: "Please Agree",
        text: "You must agree before submitting the form.",
      });
      return;
    }

    const payload = {
      candidatE_CODE: studentData.candidatE_ID || "",
      divyang: formData.divyang_val || "",
      cast: formData.caste_val || "",
    };
    try {
      const response = await fetch(
        `${config.API_BASE_URL}/UpdateEXRegularStudentRegistration_CL10`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(payload),
        }
      );

      const data = await response.json();

      setCandidateid10(data.data || "");
      setCastecode10(formData.caste_val || "");
      setDivyangcode10(formData.divyang_val || "");
      if (response.ok) {
        await Swal.fire({
          icon: "success",
          title: "Success",
          text: "Your data edited successfully",
          confirmButtonText: "OK",
        });
        if (finaledit === false) {
          setDocverify(true);
          Navigate("/class-x-upload-document");
        } else {
          Navigate("/class-x-upload-document");
        }

        // window.location.reload();
      } else {
        await Swal.fire({
          icon: "error",
          title: "Submission Failed",
          text: data.message || "Something went wrong. Please try again.",
        });
      }
    } catch (error) {
      console.error("API Error:", error);
      await Swal.fire({
        icon: "error",
        title: "Network Error",
        text: "Please check your internet connection and try again.",
      });
    }
  };
  return (
    <>
      <div class="container-scroller">
        <Navbar10 />
        <div class="container-fluid page-body-wrapper">
          <Sidebar10 />
          <div class="main-panel">
            <div class="content-wrapper">
              <div class="row">
                <div class="col-md-12 mb-1">
                  <section class="content-header">
                    <h1>
                      <i class="fa fa-user-plus"></i>&nbsp; Add Ex-Regular
                      Student (Student Registration Page for Board Examination)
                    </h1>
                    <ol class="breadcrumb">
                      <li>
                        <a
                          href="#"
                          onClick={(e) => {
                            e.preventDefault();
                            Navigate("/class-x-dashboard");
                          }}
                        >
                          <svg
                            stroke="currentColor"
                            fill="currentColor"
                            stroke-width="0"
                            viewBox="0 0 512 512"
                            height="1em"
                            width="1em"
                            xmlns="http://www.w3.org/2000/svg"
                            style={{ marginTop: "-4px" }}
                          >
                            <path d="M256 64C132.3 64 32 164.2 32 287.9c0 57 21.3 109 56.3 148.5 1.1 1.2 2.1 2.4 3.2 3.5C96.3 445 103 448 110 448c7.1 0 13.8-3 18.6-8.2 31.6-34.4 77-55.9 127.4-55.9s95.8 21.6 127.4 55.9c4.8 5.2 11.5 8.2 18.6 8.2 7 0 13.7-2.9 18.5-8.1 1.1-1.2 2.1-2.3 3.2-3.5 35-39.5 56.3-91.5 56.3-148.5C480 164.2 379.7 64 256 64zm-14 45.9c0-7.7 6.3-14 14-14s14 6.3 14 14v36c0 7.7-6.3 14-14 14s-14-6.3-14-14v-36zm-128 192H78c-7.7 0-14-6.3-14-14s6.3-14 14-14h36c7.7 0 14 6.3 14 14s-6.3 14-14 14zm51.5-104.5c-5.4 5.4-14.4 5.4-19.8 0L120.2 172c-5.4-5.4-5.4-14.4 0-19.8s14.4-5.4 19.8 0l25.5 25.5c5.4 5.4 5.4 14.3 0 19.7zm160.6 34.5l-47.5 75.5c-1.9 2.6-4.3 5.1-7 7-13.5 9.7-32.3 6.5-42-7s-6.5-32.3 7-42l75.5-47.5c3.4-2.4 8.1-2.5 11.7 0 4.5 3.2 5.5 9.5 2.3 14zm40.2-34.5c-5.4 5.4-14.4 5.4-19.8 0s-5.4-14.4 0-19.8l25.5-25.5c5.4-5.4 14.4-5.4 19.8 0s5.4 14.4 0 19.8l-25.5 25.5zM434 301.9h-36c-7.7 0-14-6.3-14-14s6.3-14 14-14h36c7.7 0 14 6.3 14 14s-6.3 14-14 14z"></path>
                          </svg>{" "}
                          Home&nbsp;
                        </a>
                      </li>
                      <li class="active"> Add Student</li>
                    </ol>
                  </section>
                </div>
              </div>
              <div class="row">
                <div class="col-lg-12 mb-4">
                  <div class="card">
                    <div class="card-header">
                      <h4 class="mb-0 p-2">Student Details</h4>
                    </div>
                    <div class="card-body">
                      <div class="row">
                        <div
                          class="col-lg-9"
                          style={{ borderRight: "1px solid #CED4DA" }}
                        >
                          <div class="row">
                            <div class="col-lg-6 col-m-6">
                              <div class="form-group  mb-3">
                                <label>
                                  Name of Student{" "}
                                  <span class="text-danger">*</span>
                                </label>
                                <div class="input-group">
                                  <input
                                    type="text"
                                    disabled
                                    class="form-control form-control-sm disable count"
                                    name="candidate_name"
                                    value={formData.candidate_name || ""}
                                  />
                                </div>
                              </div>
                            </div>
                            <div class="col-lg-3 col-m-6">
                              <div class="form-group  mb-3">
                                <label>
                                  Gender <span class="text-danger">*</span>
                                </label>
                                <input
                                  type="text"
                                  disabled
                                  class="form-control form-control-sm"
                                  value={formData.gender || ""}
                                />
                              </div>
                            </div>
                            <div class="col-lg-3 col-m-6">
                              <div class="form-group  mb-3">
                                <label>
                                  Date of Birth{" "}
                                  <span class="text-danger">*</span>
                                </label>
                                {/* <input
                                  type="date"
                                  name="birth_date"
                                  id="birth_date"
                                  disabled
                                  class="form-control form-control-sm disable"
                                  value={
                                    formData.date_of_birth
                                      .split("-")
                                      .reverse()
                                      .join("-") || ""
                                  }
                                /> */}
                                <DatePicker
                                  id="birth_date"
                                  name="birth_date"
                                  selected={
                                    formData.date_of_birth
                                      ? (() => {
                                          const [dd, mm, yyyy] =
                                            formData.date_of_birth.split("-");
                                          return new Date(
                                            Number(yyyy),
                                            Number(mm) - 1,
                                            Number(dd)
                                          );
                                        })()
                                      : null
                                  }
                                  onChange={(date) => {
                                    if (date) {
                                      const dd = String(
                                        date.getDate()
                                      ).padStart(2, "0");
                                      const mm = String(
                                        date.getMonth() + 1
                                      ).padStart(2, "0");
                                      const yyyy = date.getFullYear();

                                      setFormData({
                                        ...formData,
                                        date_of_birth: `${dd}-${mm}-${yyyy}`, // store dd-mm-yyyy
                                      });
                                    } else {
                                      setFormData({
                                        ...formData,
                                        date_of_birth: "",
                                      });
                                    }
                                  }}
                                  dateFormat="dd-MM-yyyy"
                                  className="form-control form-control-sm disable"
                                  placeholderText="dd-mm-yyyy"
                                  disabled
                                  onKeyDown={(e) => e.preventDefault()}
                                  // maxDate={new Date("2013-03-01")}
                                  showYearDropdown
                                  scrollableYearDropdown
                                  yearDropdownItemNumber={60}
                                />
                              </div>
                            </div>
                            <div class="col-lg-6 col-md-6">
                              <div class="form-group  mb-3">
                                <label>
                                  Father’s Name
                                  <span class="text-danger">*</span>
                                </label>
                                <div class="input-group">
                                  <input
                                    type="text"
                                    name="father_name"
                                    disabled
                                    class="form-control form-control-sm disable count1"
                                    value={formData.fathers_name || ""}
                                  />
                                </div>
                              </div>
                            </div>

                            <div class="col-lg-6 col-md-6">
                              <div class="form-group  mb-3">
                                <label>
                                  Mother’s Name{" "}
                                  <span class="text-danger">*</span>
                                </label>
                                <div class="input-group">
                                  <input
                                    type="text"
                                    name="mother_name"
                                    disabled
                                    class="form-control form-control-sm disable count2"
                                    value={formData.mothers_name || ""}
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="col-lg-3 col-md-12">
                          <div class="form-group mb-3">
                            <label>
                              Divyang
                              {/* <span class="text-danger">*</span> */}
                            </label>

                            <select
                              className="form-select form-select-sm"
                              id="divyang_val"
                              name="divyang_val"
                              value={formData.divyang_val}
                              onChange={handleChange}
                              // disabled={isPreviewed}
                              disabled="true"
                            >
                              <option value="">Select</option>
                              {divyangList.map((divyang) => (
                                <option
                                  key={divyang.divyanG_ID}
                                  value={divyang.divyanG_ID}
                                >
                                  {divyang.divyanG_NAME}
                                </option>
                              ))}
                            </select>
                            {/* {errors.divyang_val && (
                              <div className="text-danger mt-1 small">
                                {errors.divyang_val}
                              </div>
                            )} */}
                          </div>
                          <div class="form-group mb-3">
                            <label>
                              Caste <span class="text-danger">*</span>
                            </label>
                            <select
                              // className={`form-select form-select-sm ${
                              //   errors.caste_val ? "is-invalid" : ""
                              // }`}
                              className="form-select form-select-sm"
                              name="caste_val"
                              id="caste_val"
                              value={formData.caste_val}
                              onChange={handleChange}
                              // disabled={isPreviewed}
                              disabled="true"
                            >
                              <option value="">Choose Caste</option>
                              {casteList.map((caste) => (
                                <option
                                  key={caste.castE_ID}
                                  value={caste.castE_ID}
                                >
                                  {caste.castE_NAME}
                                </option>
                              ))}
                            </select>
                            {/* {errors.caste_val && (
                              <div className="text-danger mt-1 small">
                                {errors.caste_val}
                              </div>
                            )} */}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-lg-12 col-m-12 mb-4 stretch-card">
                  <div class="card">
                    <div class="card-header">
                      <h4 class="mb-0 p-2">Educational Details</h4>
                    </div>
                    <div class="card-body">
                      <div class="row">
                        <div class="form-group">
                          <div class="row">
                            <div class="col-lg-4 col-m-4">
                              <div class="form-group mb-3">
                                <label>
                                  Category Choice{" "}
                                  <span class="text-danger">*</span>
                                </label>
                                <input
                                  type="text"
                                  id="Category-Choice"
                                  name="choose_category"
                                  disabled
                                  class="form-control-sm form-control"
                                  value={formData.category_choice || ""}
                                />
                              </div>
                            </div>
                            <div class="col-lg-4 col-m-4">
                              <div class="form-group mb-3">
                                <label>
                                  Board Name
                                  <span class="text-danger">*</span>
                                </label>
                                <input
                                  type="text"
                                  disabled
                                  class="form-control form-control-sm"
                                  name="board_name"
                                  id="board_name"
                                  value={formData.board_name || ""}
                                />
                              </div>
                            </div>
                            <div class="col-lg-4 col-m-4">
                              <div class="form-group mb-3">
                                <label>
                                  Medium of Examination{" "}
                                  <span class="text-danger">*</span>
                                </label>
                                <select
                                  className={`form-select form-select-sm  ${
                                    errors.examination_medium
                                      ? "is-invalid"
                                      : ""
                                  }`}
                                  name="examination_medium"
                                  value={formData.examination_medium}
                                  onChange={handleChange}
                                  disabled
                                >
                                  <option value="">
                                    Choose Medium of Examination
                                  </option>
                                  {mediumList.map((medium) => (
                                    <option
                                      key={medium.mediuM_ID}
                                      value={medium.mediuM_ID}
                                    >
                                      {medium.mediuM_NAME}
                                    </option>
                                  ))}
                                </select>
                                {errors.examination_medium && (
                                  <div className="text-danger mt-1 small">
                                    {errors.examination_medium}
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-lg-4 col-m-4">
                              <div class="form-group mb-3">
                                <label>
                                  Language I Subject{" "}
                                  <span class="text-danger">*</span>
                                </label>
                                <input
                                  type="text"
                                  disabled
                                  class="form-control form-control-sm"
                                  value={`${formData.language_one || ""} ( ${
                                    formData.language_one_code || ""
                                  } )`}
                                  // value={formData.language_one || ""}
                                />
                              </div>
                            </div>
                            <div class="col-lg-4 col-m-4">
                              <div class="form-group mb-3">
                                <label>
                                  Language II Subject{" "}
                                  <span class="text-danger">*</span>
                                </label>
                                <input
                                  type="text"
                                  disabled
                                  class="form-control form-control-sm"
                                  value={`${formData.language_two || ""} ( ${
                                    formData.language_two_code || ""
                                  } )`}
                                  // value={formData.language_two || ""}
                                />
                              </div>
                            </div>
                            <div class="col-lg-4 col-m-4">
                              <div class="form-group mb-3">
                                <label>
                                  Compulsory I Subject{" "}
                                  <span class="text-danger">*</span>
                                </label>
                                <input
                                  type="text"
                                  disabled
                                  class="form-control form-control-sm"
                                  // value={formData.compulsory_one || ""}
                                  value={`${formData.compulsory_one || ""} ( ${
                                    formData.compulsory_one_code || ""
                                  } )`}
                                />
                              </div>
                            </div>
                            <div class="col-lg-4 col-m-4">
                              <div class="form-group mb-3">
                                <label>
                                  Compulsory II Subject{" "}
                                  <span class="text-danger">*</span>
                                </label>
                                <input
                                  type="text"
                                  disabled
                                  class="form-control form-control-sm"
                                  // value={formData.compulsory_two || ""}
                                  value={`${formData.compulsory_two || ""} ( ${
                                    formData.compulsory_two_code || ""
                                  } )`}
                                />
                              </div>
                            </div>
                            <div class="col-lg-4 col-m-4">
                              <div class="form-group mb-3">
                                <label>
                                  Compulsory III Subject{" "}
                                  <span class="text-danger">*</span>
                                </label>
                                <input
                                  type="text"
                                  disabled
                                  class="form-control form-control-sm"
                                  value={`${
                                    formData.compulsory_three || ""
                                  } ( ${
                                    formData.compulsory_three_code || ""
                                  } )`}
                                  // value={formData.compulsory_three || ""}
                                />
                              </div>
                            </div>
                            <div class="col-lg-4 col-m-4">
                              <div class="form-group mb-3">
                                <label>
                                  Additional subject{" "}
                                  <span class="text-danger">*</span>
                                </label>
                                <input
                                  type="text"
                                  disabled
                                  class="form-control form-control-sm"
                                  value={`${
                                    formData.additional_subject || ""
                                  } ( ${
                                    formData.additional_subject_code || ""
                                  } )`}
                                  // value={formData.additional_subject || ""}
                                />
                              </div>
                            </div>
                            <div
                              class="col-lg-4 col-m-4"
                              id="Registration-Session"
                            >
                              <div class="form-group mb-3">
                                <label>
                                  Registration Session{" "}
                                  <span class="text-danger">*</span>
                                </label>
                                <input
                                  type="text"
                                  class="form-control form-control-sm"
                                  value={formData.reg_session_name || ""}
                                  disabled
                                />
                              </div>
                            </div>
                            <div
                              class="col-lg-4 col-m-4"
                              id="Registration-Number"
                            >
                              <div class="form-group mb-3">
                                <label>
                                  Registration Number{" "}
                                  <span class="text-danger">*</span>
                                </label>
                                <input
                                  type="text"
                                  disabled
                                  class="form-control form-control-sm"
                                  name="registration_number"
                                  id="registration_number"
                                  value={formData.registration_no || ""}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="card">
                    <div class="card-body">
                      <div className="row">
                        <div className="col-md-8">
                          {isPreviewed && (
                            <h5 style={{ color: "red" }}>
                              <input
                                type="checkbox"
                                checked={isAgreed}
                                onChange={(e) => setIsAgreed(e.target.checked)}
                              />{" "}
                              I AGREE THAT ALL THE INFORMATION GIVEN ABOVE IS
                              CORRECT AS PER MY BEST KNOWLEDGE.
                            </h5>
                          )}
                        </div>
                        <div
                          style={{ textAlign: "right" }}
                          className="col-md-4"
                        >
                          {isEditMode ? (
                            <>
                              <button
                                onClick={handleEditClick}
                                type="button"
                                className="btn btn-primary"
                              >
                                <i className="fa fa-edit me-1"></i> Edit
                              </button>
                              &nbsp;&nbsp;
                              <button
                                type="button"
                                onClick={handleContinueClick}
                                className="btn btn-success me-2"
                              >
                                Next <i className="fa fa-arrow-right me-1"></i>
                              </button>
                            </>
                          ) : isPreviewed ? (
                            <>
                              <button
                                onClick={handleButtonClick}
                                type="button"
                                className="btn btn-primary pull-right"
                              >
                                <i className="fa fa-save me-1"></i>
                                Submit
                              </button>
                              <button
                                type="button"
                                onClick={() => setIsPreviewed(false)}
                                className="btn btn-secondary me-2"
                              >
                                <i className="fa fa-edit me-1"></i> Edit
                              </button>
                            </>
                          ) : (
                            <button
                              type="button"
                              className="btn btn-secondary me-2"
                              onClick={handlePreview}
                            >
                              <i className="fa fa-eye me-1"></i> Preview
                            </button>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <Footer10 />
          </div>
        </div>
      </div>
    </>
  );
}

export default Exregularsecond10;
